import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";
import axios from "axios";
axios.defaults.baseURL = process.env.REACT_APP_API_URL || "https://api.behinlab.com"

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render( <
    Provider store = { store } >
    <
    React.StrictMode >
    <
    App / >
    <
    /React.StrictMode> < /
    Provider > ,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();